<div class="dropdown periodicidade-picker">
    <button class="btn btn-light dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" [title]="periodicidade | periodicidade"
        [disabled]="!canSelect"
        [style.borderTopLeftRadius]="borderTopLeftRadius"
        [style.borderBottomLeftRadius]="borderBottomLeftRadius"
        [style.borderTopRightRadius]="borderTopRightRadius"
        [style.borderBottomRightRadius]="borderBottomRightRadius">
        {{periodicidade | periodicidadeSigla}}
    </button>
    <div class="dropdown-menu">
        <ng-template ngFor let-periodicidadeItem [ngForOf]="periodicidades">
            <a class="dropdown-item" [class.active]="periodicidade === periodicidadeItem.id" (click)="onChange(periodicidadeItem)">
                {{periodicidadeItem.nome}}
            </a>
        </ng-template>
    </div>
</div>